import Vue from 'vue'
import {isCourseAuth} from '@/utils/utils';

/**
 * 课程的权限控制
 */
function updateDom(el:any,binding:any,vnode:any, oldVnode:any){
  let bindVal    = binding.value;
  let moduleName = '';
  let modeType   = 'disabled';//disabled or hide or if
  if(typeof(bindVal) == 'object'){
    moduleName  = bindVal.type;
    modeType    = bindVal.mode;
  }else{
    moduleName = bindVal;
  }
  let isAllow = isCourseAuth(moduleName);
  if(isAllow == false){
    if(modeType == 'disabled'){
      el.setAttribute('disabled','disabled');
      el.setAttribute('title','您没有权限操作，请联系课程管理员进行授权');
      let classLists = el.getAttribute('class');
      if(classLists != null && classLists.indexOf("is-disabled") > -1){
        return;
      }else{
        //@ts-ignore
        if(classLists != null){
          classLists = classLists?.concat(' is-disabled');
          //@ts-ignore
          el.setAttribute('class',classLists);
        }else{
          el.setAttribute('class',"is-disabled");
        }
      } 
    }else if(modeType == 'if'){
      el.remove();
    }else{
      el.style.display='none';
    }
  }else{
    if(modeType == 'disabled'){
      el.removeAttribute('disabled');
      el.removeAttribute('title');
      let classLists = el.getAttribute('class');
      //@ts-ignore
      classLists = classLists?.replaceAll('is-disabled',"");
      //@ts-ignore
      el.setAttribute('class',classLists);
    }else if(modeType == 'if'){
      
    }else{
      el.style.display='block';
    }
  }
};

Vue.directive('courseauth', {
  bind(el, binding, vnode, oldVnode) {
    updateDom(el, binding, vnode, oldVnode);
  },
  update(el, binding, vnode, oldVnode){
    updateDom(el, binding, vnode, oldVnode);
  }
})